import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './shared/errors/not-found/not-found.component';
import { UnauthorizedComponent } from './shared/errors/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./home/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'vehicles',
    loadChildren: () => import('./vehicles/vehicle.module').then(m => m.VehicleModule)
  },
  {
    path: 'inventory',
    loadChildren: () => import('./vehicles/inventory.module').then(m => m.InventoryModule)
  },
  {
    path: 'sales',
    loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'system-admin',
    loadChildren: () => import('./system-admin/system-admin.module').then(m => m.SystemAdminModule)
  },
  {
    path: 'unauthorized',
    title: 'Unauthorized - WebbDMS',
    component: UnauthorizedComponent
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    title: 'Page Not Found - WebbDMS',
    component: NotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
